import * as React from 'react';
import CloseButton from '@core-front/close-button';
import PageAccess from '@core-front/page-access';
import TooltipCore from './tooltip-core';
export var TooltipColors;
(function (TooltipColors) {
    TooltipColors["info"] = "info";
    TooltipColors["success"] = "success";
    TooltipColors["error"] = "error";
    TooltipColors["employee"] = "employee";
})(TooltipColors || (TooltipColors = {}));
const Tooltip = (props) => {
    return (React.createElement(TooltipCore, Object.assign({}, props, { components: {
            CloseButton,
            PageAccess,
        } })));
};
export default Tooltip;
